<template>
  <div class="student-map-kpi-strip policy-kpi-strip" aria-label="实训指标和财政使用情况">
    <article v-for="item in items" :key="item.key" class="student-map-kpi-card" :data-kpi="item.key" :title="(item.description || item.name) + (item.unit ? '（' + item.unit + '）' : '')">
      <div class="policy-kpi-heading"><span class="student-map-kpi-icon" :style="{ background: item.color }">{{ item.icon }}</span><span class="student-map-kpi-name">{{ item.name }}</span><small v-if="item.unit" class="policy-kpi-unit">{{ item.unit }}</small></div>
      <policy-progress-bar :value="item.value" :target="item.target" :label="item.name" :unit="item.unit || ''" :color="item.color" :budget="item.key === 'budget-usage'" show-values hide-unit />
    </article>
  </div>
</template>

<script>
import PolicyProgressBar from './PolicyProgressBar.vue'

export default {
  name: 'PolicyKpiStrip', components: { PolicyProgressBar },
  props: { items: { type: Array, default: () => [] } }
}
</script>
